function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
}

function extensionForMime(mimeType) {
  return String(mimeType || '').includes('mp4') ? 'mp4' : 'webm';
}

function generateRecordingFileName(extension) {
  const part = () => Math.random().toString(36).slice(2, 8);
  const stamp = new Date().toISOString().replace(/[-:TZ.]/g, '').slice(0, 14);

  return `rec_${part()}_${stamp}_${part()}.${extension}`;
}

function defaultMetaResolver(channel, page) {
  const card = document.querySelector(`.gv-media-card[data-channel="${CSS.escape(channel)}"]`)
    || document.querySelector(`.product-live-streams__card[data-channel="${CSS.escape(channel)}"]`)
    || document.querySelector(`.gv-media-card[data-video-id="${CSS.escape(channel)}"]`);

  return {
    streamTitle: card?.dataset.streamTitle?.trim() || card?.dataset.videoTitle?.trim() || '',
    gameId: page?.dataset.gameId?.trim() || '',
    gameUuid: page?.dataset.game?.trim() || '',
  };
}

export async function uploadRecording({
  blob,
  mimeType,
  channel,
  page,
  startedAt,
  durationSeconds,
  uploadUrl,
  onProgress,
  metaResolver,
}) {
  const meta = typeof metaResolver === 'function'
    ? metaResolver(channel, page)
    : defaultMetaResolver(channel, page);
  const extension = extensionForMime(mimeType);
  const formData = new FormData();
  formData.append('file', blob, generateRecordingFileName(extension));
  formData.append('channel', channel);
  formData.append('game_id', meta.gameId);
  formData.append('game_uuid', meta.gameUuid);
  formData.append('stream_title', meta.streamTitle);
  formData.append('duration_seconds', String(Math.max(1, durationSeconds)));
  formData.append('started_at', startedAt.toISOString());

  const token = csrfToken();

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', uploadUrl);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    if (token) {
      xhr.setRequestHeader('X-CSRF-TOKEN', token);
    }

    xhr.upload.addEventListener('progress', (event) => {
      if (!event.lengthComputable || typeof onProgress !== 'function') {
        return;
      }

      onProgress(Math.min(100, Math.round((event.loaded / event.total) * 100)));
    });

    xhr.addEventListener('load', () => {
      let json = {};
      let parsed = false;
      try {
        json = JSON.parse(xhr.responseText || '{}');
        parsed = true;
      } catch {
        json = {};
      }

      if (xhr.status >= 200 && xhr.status < 300 && json.success) {
        resolve(json);
        return;
      }

      const firstError = json.errors ? Object.values(json.errors).flat()[0] : null;
      let message = firstError || json.error || json.message;

      if (!message) {
        if (xhr.status === 419) {
          message = 'نشست منقضی شده (CSRF). صفحه را رفرش کنید و دوباره تلاش کنید.';
        } else if (xhr.status === 413) {
          message = 'حجم فایل ضبط بیش از حد مجاز سرور است.';
        } else if (!parsed && xhr.responseText) {
          message = xhr.responseText.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 200);
        }
      }

      if (!message) {
        message = 'خطا در ذخیره ضبط';
      }

      reject(new Error(`${message} (HTTP ${xhr.status})`));
    });

    xhr.addEventListener('error', () => {
      reject(new Error('خطا در ارسال فایل ضبط'));
    });

    xhr.addEventListener('abort', () => {
      reject(new Error('آپلود لغو شد'));
    });

    xhr.send(formData);
  });
}
